// Selector shorthand normalizer for generated loop output.
// Example: ".m-1:{" -> ".m-1 {".

// Normalize selector shorthand like `.m-1:{` into `.m-1 {`.
export function normalizeSelectorColonBeforeBrace(source: string): string {
  // Return source directly when shorthand marker is not present.
  if (!source.includes(':{') && !source.includes(': {')) {
    return source
  } else {
    // Continue line-level selector shorthand normalization.
  }

  const lines = source.split(/\r?\n/)
  // Rewrite line endings that use selector-colon shorthand before `{`.
  const normalized = lines
    .map((line) => {
      const trimmed = line.trim()
      // Keep property-like lines untouched to avoid false positives.
      if (trimmed.includes(';')) {
        // Return unchanged property-like line.
        return line
      } else {
        // Continue shorthand selector check.
      }

      // Rewrite only when line ends with `:{` or `: {`.
      if (!trimmed.match(/:\s*\{$/)) {
        // Return unchanged line when shorthand is absent.
        return line
      } else {
        // Return normalized selector line.
        return line.replace(/:\s*\{$/, ' {')
      }
    })
    .join('\n')

  // Return selector-normalized text.
  return normalized
}
